const sessionStorageConstants = {
  sessionUuid: 'session_uuid'
};

export default sessionStorageConstants;
